export const isPhoneNumberValid = (phoneNumber: string) => {
  const regexp = new RegExp(/^(09|\u06F0\u06F9)[\d\u06F0-\u06F9]{9}$/);
  if (regexp.test(phoneNumber)) return true;
  return false;
};
